import React from 'react';
import AllProducts from '../AllProducts/AllProducts';
import Header from '../Header/Header';

const Home = () => {
    return (
        <div>
            <Header />
            <AllProducts />
        </div>
    );
};

export default Home;